import { createSlice } from '@reduxjs/toolkit'
import { StripePaymentRequest } from 'models/StripePaymentRequest'
import { Dispatch } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

interface PaymentMethodStatus {
  digitalWallets: StripePaymentRequest
  venmo: {
    isReady: boolean
  }
}

const initialState: PaymentMethodStatus = {
  digitalWallets: {
    walletType: 'GPAY',
    canMakePayment: false,
  },
  venmo: {
    isReady: false,
  },
}

export const paymentMethodStatusSlice = createSlice({
  name: 'pmStatus',
  initialState,
  reducers: {
    setStripeDWStatus: (state, { payload }: { payload: StripePaymentRequest }) => {
      state.digitalWallets = payload
    },
    setVenmoReady: (state, { payload }: { payload: boolean }) => {
      state.venmo.isReady = payload
    },
  },
})

export const { setStripeDWStatus, setVenmoReady } = paymentMethodStatusSlice.actions

export const getStripeDWStatus = () => (_dispatch: Dispatch, getState: () => RootState) => {
  const state = getState()

  return state.order.pmStatus.digitalWallets
}

export default paymentMethodStatusSlice.reducer
